<template>
    <div v-loading="isSuccess" class="mexam_view">
        <div class="top_time_box">
            <div>
                <img :src="require('@/common/images/examImgs/icon_clock.png')" alt="">
                <span v-if="examInfoData.isastrict === 0">考试中</span>
                <van-count-down v-if="examInfoData.isastrict === 1" :time="time" />
            </div>
            <div>
                <!-- <span>{{answerKyesInfoData.usecount}}</span> -->
                <span>{{page}}</span>
                <span>/{{answerKyesInfoData.allcount}}</span>
            </div>
        </div>
        <div class="exam_warp_box">
            <div class="subject_box">
                <p class="p_text">{{page}}.【{{examInfoData.questioninfo[0].questiontypename}}，{{examInfoData.questioninfo[0].quesscore}}分】</p>
                <p class="p_text" v-html="examInfoData.questioninfo[0].subject"></p>
                <div v-if="examInfoData.questioninfo[0].questiontype === 1" class="answer_box answer_type1">
                    <van-checkbox-group v-model="result" ref="checkboxGroup">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in list" clickable :key="index"  @click="singleChoiceClick(index)">
                                <van-checkbox :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem">
                                    <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                    <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                </van-checkbox>
                            </van-cell>
                        </van-cell-group>
                    </van-checkbox-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 2 || examInfoData.questioninfo[0].questiontype === 3" class="answer_box answer_type2">
                    <van-checkbox-group v-model="result">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in list" clickable :key="index"  @click="toggle(index)">
                                <van-checkbox :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem" shape="square">
                                    <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                    <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                </van-checkbox>
                            </van-cell>
                        </van-cell-group>
                    </van-checkbox-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 4" class="answer_box answer_type5">
                    <van-checkbox-group v-model="result" ref="checkboxGroup">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in list" clickable :key="index"  @click="singleChoiceClick(index)">
                                <van-checkbox :name="item.optionsvalue" ref="checkboxes" icon-size="0.22rem">
                                    <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                </van-checkbox>
                            </van-cell>
                        </van-cell-group>
                    </van-checkbox-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 5" class="answer_box answer_type3">
                    <van-cell-group>
                        <van-cell v-for="(item, index) in textInputData" clickable :key="index">
                            <van-field v-model="item.inputtext" :label="'（'+(index+1)+'）'" placeholder="请填写答案" />
                        </van-cell>
                    </van-cell-group>
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 6" class="answer_box answer_type4">
                    <van-field v-model="message" rows="6" autosize  type="textarea" placeholder="请填写答案" />
                </div>
                <div v-if="examInfoData.questioninfo[0].questiontype === 7" class="answer_box answer_type7">
                    <div class="item" v-for="(obj, i) in examInfoData.questioninfo[0].questioninfo" :key="i">
                        <p class="p_text">{{examInfoData.questioninfo[0].questionindex}}.{{obj.questionindex}}【{{obj.questiontypename}}，{{obj.quesscore}}分】</p>
                        <p class="p_text" v-html="obj.subject"></p>
                        <div v-if="obj.questiontype === 1" class="answer_box materials_answer_box answer_type1">
                            <van-checkbox-group v-model="obj.result" :ref="`checkboxGroup${i}`">
                                <van-cell-group>
                                    <van-cell v-for="(item, index) in obj.list" clickable :key="index"  @click="materialsSingleChoiceClick(i, index)">
                                        <van-checkbox :name="item.optionsvalue" :ref="`checkboxes${i}${index}`" icon-size="0.22rem">
                                            <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                            <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                        </van-checkbox>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </div>
                        <div v-if="obj.questiontype === 2 || obj.questiontype === 3" class="answer_box materials_answer_box answer_type2">
                            <van-checkbox-group v-model="obj.result">
                                <van-cell-group>
                                    <van-cell v-for="(item, index) in obj.list" clickable :key="index"  @click="materialsToggle(i, index)">
                                        <van-checkbox :name="item.optionsvalue" :ref="`checkboxes${i}${index}`" icon-size="0.22rem" shape="square">
                                            <span style="color: #909399; font-size: 0.28rem;">{{item.optionsvalue}}.</span>
                                            <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                        </van-checkbox>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </div>
                        <div v-if="obj.questiontype === 4" class="answer_box materials_answer_box answer_type5">
                            <van-checkbox-group v-model="obj.result" :ref="`checkboxGroup${i}`">
                                <van-cell-group>
                                    <van-cell v-for="(item, index) in obj.list" clickable :key="index"  @click="materialsSingleChoiceClick(i, index)">
                                        <van-checkbox :name="item.optionsvalue" :ref="`checkboxes${i}${index}`" icon-size="0.22rem">
                                            <span style="font-size: 0.28rem; margin-left: 0.16rem;" v-html="item.optionsinfo" class="optionsinfoItem"></span>
                                        </van-checkbox>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </div>
                        <div v-if="obj.questiontype === 5" class="answer_box materials_answer_box answer_type3">
                            <van-cell-group>
                                <van-cell v-for="(item, index) in obj.textInputData" clickable :key="index">
                                    <van-field v-model="item.inputtext" :label="'（'+(index+1)+'）'" placeholder="请填写答案" />
                                </van-cell>
                            </van-cell-group>
                        </div>
                        <div v-if="obj.questiontype === 6" class="answer_box materials_answer_box answer_type4">
                            <van-field v-model="obj.message" rows="6" autosize  type="textarea" placeholder="请填写答案" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_handle_box">
            <div @click="upQuestion" class="handle_div">
                <img style="margin-right: 0.08rem;" :src="require('@/common/images/examImgs/icon_up.png')" alt="">
                <span>上一题</span>
            </div>
            <div class="scantron_box" @click="answerSheetClick">
                <img :src="require('@/common/images/examImgs/icon_answer.png')" alt="">
                <span>答题卡</span>
            </div>
            <div @click="nextQuestion" class="handle_div">
                <span>下一题</span>
                <img style="margin-left: 0.1rem;" :src="require('@/common/images/examImgs/icon_down.png')" alt="">
            </div>
        </div>
        <div class="answer_sheet_pop_box">
            <van-popup v-model="showAnswerSheet" position="bottom" :style="{ height: '100vh' }">
                <div class="answer_sheet_content_box">
                    <div class="answer_title_box">
                        <img @click="showAnswerSheet = false" :src="require('@/common/images/examImgs/icon_close_blue.png')" alt="">
                        答题卡
                    </div>
                    <div class="answer_select_box">
                        <div class="answer_item_box" v-for="(item, index) in answerKyesInfoData.answerkeysinfo" :key="index">
                            <div @click="subjectClick(index+1)" :class="item.status === 1 ? 'finished' : ''">
                                {{index+1}}
                            </div>
                        </div>
                    </div>
                    <div class="answer_bottom_box">
                        <div>
                            <span>已做</span>
                            <div></div>
                            <span>未做</span>
                            <div></div>
                        </div>
                        <div>
                            <div @click="submitTestPaper">提交试卷</div>
                            <div @click="saveProgressClick">保存进度，下次继续</div>
                        </div>
                    </div>
                </div>
            </van-popup>
        </div>
        <div class="save_progress_pop">
            <van-popup v-model="saveProgressPop" @close="closePop" position="center">
                <div class="save_progress_div">
                    <div>
                        <img class="save_progress_img" :src="require('@/common/images/examImgs/icon_save.png')" alt="">
                        <p>进度保存成功</p>
                        <p>下次进来将保留你的答题进度</p>
                        <van-button @click="saveProgressSureBtn" type="primary">确认</van-button>
                    </div>
                </div>
            </van-popup>
        </div>
        <div class="save_progress_pop">
            <van-popup v-model="examEndPop" @close="closePop2" position="center">
                <div class="save_progress_div">
                    <div>
                        <img class="save_progress_img" :src="require('@/common/images/examImgs/icon_save.png')" alt="">
                        <p>考试时间已到</p>
                        <p>快去查看您的考试结果吧！</p>
                        <van-button @click="toExamResult" type="primary">查看结果</van-button>
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
import {Toast} from 'vant'
import {getQuestionList, updateUserexamInfo, saveExamRecord, getAnswerSheetInfo} from 'api/examApi'
import {mapGetters, mapActions} from 'vuex'
import {uploadPauseExam} from 'api/api'
// import $ from 'jquery'
export default {
    name: 'MExamView',
    data() {
        return {
            isSuccess: true,
            examEndPop: false,
            saveProgressPop: false, // 保存进度成功弹窗
            // time: 1.5 * 60 * 60 * 1000,
            time: 0,
            time2: 0,
            showAnswerSheet: false,
            list: [],
            result: [],
            page: 1,
            answerKyesInfoData: {
                allcount: 0,
                usecount: 0,
                answerkeysinfo: []
            },
            examInfoData: {
                pageinfo: {
                    pageCount: 1,
                    rowCount: 100
                },
                questioninfo: [{}]
            },
            textInputData: [],
            message: '',
            localexamtime: 0,
            localexamtimer: null
        }
    },
    mounted() {
        if (!this.refresh) {
            this.findQuestionList('第一次')
            this.findAnswerSheetInfo()
        }
    },
    beforeDestroy() {
        
    },
    activated () {
        if (this.refresh) {
            this.saveProgressPop = false
            this.showAnswerSheet = false
            this.page = 1
            this.time2 = 1000 * 5400
            this.findQuestionList('第一次')
            this.findAnswerSheetInfo()
            this.setRefresh(false)
        }
    },
    deactivated() {
        if (this.localexamtimer) {
            clearInterval(this.localexamtimer)
        }
    },
    methods: {
        // 点击答题卡
        answerSheetClick() {
            this.submitExamAnswer()
            // this.findAnswerSheetInfo()
            this.showAnswerSheet = true
        },
        // 获取答题卡信息
        findAnswerSheetInfo() {
            this.isSuccess = true
            // this.setLoading(true)
            var params = {
                exampid: this.$route.query.examid
            }
            getAnswerSheetInfo({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    // console.log(data.data)
                    // this.showAnswerSheet = true
                    this.isSuccess = false
                    this.answerKyesInfoData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取试题信息
        findQuestionList(val) {
            this.isSuccess = true
            // this.setLoading(true)
            var params = {
                clienttype: 2,
                examid: this.$route.query.examid,
                page: this.page
            }
            getQuestionList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.isSuccess = false
                    this.showAnswerSheet = false
                    if (data.data.isastrict === 1) {
                        if (val === '第一次') {
                            this.time = data.data.examsurtimes * 1000
                            this.time2 = data.data.examsurtimes * 1000
                            // this.time = 10 * 1000
                            // setTimeout(()=>{
                            //     this.time = this.time - 1000
                            // }, 1000)
                        }
                        this.localexamtimer = setInterval(() => {
                            this.localexamtime++
                        }, 1000)
                    }
                    if (data.data.questioninfo[0].questiontype === 1 || data.data.questioninfo[0].questiontype === 2 || data.data.questioninfo[0].questiontype === 3) {
                        this.list = data.data.questioninfo[0].optionslist
                        if (data.data.questioninfo[0].issubmit === 1) {
                            this.result = data.data.questioninfo[0].uselanswer.split(',')
                        } else {
                            this.$nextTick(() => {
                                this.result = []
                            })
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 4) {
                        this.list = [
                            {
                                optionsvalue: 'T',
                                optionsinfo: '正确'
                            },
                            {
                                optionsvalue: 'F',
                                optionsinfo: '错误'
                            }
                        ]
                        if (data.data.questioninfo[0].issubmit === 1) {
                            this.result = data.data.questioninfo[0].uselanswer.split(',')
                        } else {
                            this.result = []
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 5) {
                        this.textInputData = []
                        for (let i = 0; i < data.data.questioninfo[0].finalanswerblank.answerblank.length; i++) {
                            this.textInputData.push({inputtext: ''})
                        }
                        if (data.data.questioninfo[0].issubmit === 1) {
                            var testInput = data.data.questioninfo[0].uselanswer.split('|')
                            for (let j = 0; j < testInput.length; j++) {
                                this.textInputData[j].inputtext = testInput[j]
                            }
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 6) {
                        if (data.data.questioninfo[0].issubmit === 1) {
                            this.message = data.data.questioninfo[0].uselanswer
                        } else {
                            this.message = ''
                        }
                    }
                    if (data.data.questioninfo[0].questiontype === 7) {
                        // const obj = {
                        //     innerid: "nurR8qeQLmhk5Qmq",
                        //     issubmit: 0,
                        //     optionslist: [{optionsindex: 1, optionsvalue: "A", optionsinfo: "1"}, {optionsindex: 2, optionsvalue: "B", optionsinfo: "2"}],
                        //     quesscore: 10,
                        //     questionindex: 1,
                        //     questiontype: 1,
                        //     questiontypename: "单选题",
                        //     subject: "<p>1+1=</p>",
                        //     uselanswer: ""
                        // }
                        // const obj2 = {
                        //     innerid: "nurR8qeQLmhk5Qmq",
                        //     issubmit: 0,
                        //     optionslist: [{optionsindex: 1, optionsvalue: "A", optionsinfo: "1"}, {optionsindex: 2, optionsvalue: "B", optionsinfo: "2"}],
                        //     quesscore: 10,
                        //     questionindex: 2,
                        //     questiontype: 1,
                        //     questiontypename: "单选题",
                        //     subject: "<p>1+1=</p>",
                        //     uselanswer: ""
                        // }
                        // this.examInfoData.questioninfo[0].questioninfo.push(obj)
                        // this.examInfoData.questioninfo[0].questioninfo.push(obj2)
                        data.data.questioninfo[0].questioninfo.forEach((obj) => {
                            if (obj.questiontype === 1 || obj.questiontype === 2 || obj.questiontype === 3) {
                                obj.list = obj.optionslist
                                // console.log(obj.issubmit)
                                if (obj.issubmit === 1) {
                                    obj.result = obj.uselanswer.split(',')
                                } else {
                                    obj.result = []
                                    // this.$nextTick(() => {
                                    // })
                                }
                                // console.log(obj.result)
                            }
                            if (obj.questiontype === 4) {
                                obj.list = [
                                    {
                                        optionsvalue: 'T',
                                        optionsinfo: '正确'
                                    },
                                    {
                                        optionsvalue: 'F',
                                        optionsinfo: '错误'
                                    }
                                ]
                                if (obj.issubmit === 1) {
                                    obj.result = obj.uselanswer.split(',')
                                } else {
                                    obj.result = []
                                }
                            }
                            if (obj.questiontype === 5) {
                                obj.textInputData = []
                                for (let i = 0; i < obj.finalanswerblank.answerblank.length; i++) {
                                    obj.textInputData.push({inputtext: ''})
                                }
                                if (obj.issubmit === 1) {
                                    var testInput = obj.uselanswer.split('|')
                                    for (let j = 0; j < testInput.length; j++) {
                                        obj.textInputData[j].inputtext = testInput[j]
                                    }
                                }
                            }
                            if (obj.questiontype === 6) {
                                if (obj.issubmit === 1) {
                                    obj.message = obj.uselanswer
                                } else {
                                    obj.message = ''
                                }
                            }
                        })
                        // this.examInfoData = this.examInfoData
                    }
                    this.examInfoData = data.data
                    console.log(this.examInfoData.questioninfo[0])
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        
        // 提交试卷
        submitTestPaper() {
            // console.log(this.result)
            // this.submitExamAnswer(1)
            this.submitUserexamInfo()
        },
        // 上一题
        upQuestion() {
            if (this.page === 1) {
                Toast('当前已是第一题')
            } else {
                this.submitExamAnswer()
                // this.findAnswerSheetInfo()
                this.page = this.page - 1
                this.findQuestionList()
            }
        },
        // 下一题
        nextQuestion() {
            if (this.page === this.examInfoData.pageinfo.rowCount) {
                Toast('当前已是最后一题')
            } else {
                this.submitExamAnswer()
                // this.findAnswerSheetInfo()
                this.page = this.page + 1
                this.findQuestionList()
            }
        },
        // 提交考试答案
        submitExamAnswer(val) {
            var questioninfoData = {
                innerid: this.examInfoData.questioninfo[0].innerid,
                questiontype: this.examInfoData.questioninfo[0].questiontype,
                uselanswer: '',
                questioninfo: []
            }
            if (questioninfoData.questiontype === 1 || questioninfoData.questiontype === 2 || questioninfoData.questiontype === 3 || questioninfoData.questiontype === 4) {
                // console.log('多选：', this.result)
                if (this.result.length === 0) {
                    questioninfoData.uselanswer = ''
                } else {
                    questioninfoData.uselanswer = this.result.join(',')
                }
            }
            if (questioninfoData.questiontype === 5) {
                // console.log(this.textInputData)
                var inputs = []
                for (let i = 0; i < this.textInputData.length; i++) {
                    // if (this.textInputData[i].inputtext !== '') {
                        inputs.push(this.textInputData[i].inputtext)
                    // }
                }
                
                inputs = inputs.join('|')
                // 填空题判断是否答题
                var isDo = false
                for (let j = 0; j < this.textInputData.length; j++) {
                    if (this.textInputData[j].inputtext !== '') {
                        isDo = true
                        break
                    }
                }
                if (isDo) {
                    questioninfoData.uselanswer = inputs
                } else {
                    questioninfoData.uselanswer = ''
                }
            }
            if (questioninfoData.questiontype === 6) {
                // console.log(this.message)
                questioninfoData.uselanswer = this.message
            }
            if (questioninfoData.questiontype === 7) {
                console.log(this.examInfoData.questioninfo[0].questioninfo)
                this.examInfoData.questioninfo[0].questioninfo.forEach(obj => {
                    let item = {
                        "innerid": obj.innerid,
                        "questiontype": obj.questiontype,
                        "uselanswer": ''
                    }
                    if (obj.questiontype === 1 || obj.questiontype === 2 || obj.questiontype === 3 || obj.questiontype === 4) {
                        // console.log('多选：', this.result)
                        if (obj.result.length === 0) {
                            item.uselanswer = ''
                        } else {
                            item.uselanswer = obj.result.join(',')
                        }
                    }
                    if (obj.questiontype === 5) {
                        // console.log(this.textInputData)
                        var inputs = []
                        for (let i = 0; i < obj.textInputData.length; i++) {
                            // if (this.textInputData[i].inputtext !== '') {
                                inputs.push(obj.textInputData[i].inputtext)
                            // }
                        }
                        
                        inputs = inputs.join('|')
                        // 填空题判断是否答题
                        var isDo = false
                        for (let j = 0; j < obj.textInputData.length; j++) {
                            if (obj.textInputData[j].inputtext !== '') {
                                isDo = true
                                break
                            }
                        }
                        if (isDo) {
                            item.uselanswer = inputs
                        } else {
                            item.uselanswer = ''
                        }
                    }
                    if (item.questiontype === 6) {
                        // console.log(this.message)
                        item.uselanswer = obj.message
                    }
                    questioninfoData.questioninfo.push(item)
                })
            }
            // console.log('questioninfoData:', questioninfoData)
            questioninfoData = [questioninfoData]
            this.isSuccess = true
            // this.setLoading(true)
            var params = {
                exampid: this.$route.query.examid,
                questioninfo: JSON.stringify(questioninfoData)
            }
            saveExamRecord({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.isSuccess = false
                    // console.log(data.data)
                    this.findAnswerSheetInfo()
                    if (data) {
                        if (val === 1) {
                            // console.log('提交试卷')
                            this.submitUserexamInfo()
                        }
                        if (val === 2) {
                            this.uploadPauseExam()
                            
                        }
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 提交考试信息
        submitUserexamInfo() {
            this.isSuccess = true
            // this.setLoading(true)
            var params = {
                exampid: this.$route.query.examid
            }
            updateUserexamInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.isSuccess = false
                    // console.log(data.data)
                    if (data) {
                        this.setRefresh(true)
                        // 提交考试成功  跳转到考试结果页面
                        this.$router.push({name: 'MExamResult', query: {exampid: this.examInfoData.examinnerid}})
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        singleChoiceClick(index) {
            this.$refs.checkboxGroup.toggleAll(false)
            this.$refs.checkboxes[index].toggle()
        },
        // 材料题单独处理
        materialsSingleChoiceClick(i, index) {
            // console.log(this.$refs, i, this.$refs[`checkboxGroup${i}`])
            this.$refs['checkboxGroup' + i][0].toggleAll(false)
            this.$refs['checkboxes' + i + index][0].toggle()
            console.log(i, index, this.$refs['checkboxes' + i + index])
        },
        toggle(index) {
            this.$refs.checkboxes[index].toggle()
        },
        // 材料题单独处理
        materialsToggle(i, index) {
            // this.$refs.checkboxes[index].toggle()
            this.$refs[`checkboxes${i}${index}`][0].toggle()
            console.log(i, index)
        },
        // 答题卡快捷点击
        subjectClick(val) {
            this.page = val
            this.findQuestionList()
            // Toast(val)
        },
        // 答题卡保存进度按钮
        saveProgressClick() {
            this.submitExamAnswer(2)
        },
        // 暂停考试
        uploadPauseExam() {
            this.setLoading(true)
            uploadPauseExam({
                data: {userexamid: this.$route.query.examid, localexamtime: this.localexamtime},
                success: res => {
                    this.setLoading(false)
                    this.saveProgressPop = true
                },
                error: res => {
                    this.setLoading(false)
                }
            })
        },
        // 保存进度成功弹窗内 确认 按钮
        saveProgressSureBtn() {
            this.saveProgressPop = false
            this.showAnswerSheet = false
            console.log(this.saveProgressPop)
            // 回到题库详情
            this.$router.push({name: 'PaperDetails', query: {qid: this.examInfoData.assetinnerid}})
        },
        // 关闭保存进度成功弹窗
        closePop() {
            // console.log('关闭弹窗')
            this.showAnswerSheet = false
            this.$router.push({name: 'PaperDetails', query: {qid: this.examInfoData.assetinnerid}})
        },
        // 查看考试结果弹窗
        toExamResult() {
            this.setRefresh(true)
            this.submitExamAnswer(1) // 关闭弹窗或者点击查看结果按钮提交当前题答案  提交答案成功后提交考试试卷
            // 点击弹窗内考试查看结果按钮
            // this.$router.push({name: 'MExamResult', query: {exampid: this.examInfoData.examinnerid}})
        },
        // 关闭保存进度成功弹窗
        closePop2() {
            this.setRefresh(true)
            this.submitExamAnswer(1) // 关闭弹窗或者点击查看结果按钮提交当前题答案  提交答案成功后提交考试试卷
            // 点击弹窗内考试查看结果按钮
            // this.$router.push({name: 'MExamResult', query: {exampid: this.examInfoData.examinnerid}})
        },
        // discountCountdown(value) {
        //     var date = value
        //     date = date.substring(0, 19)
        //     date = date.replace(/-/g, '/')
        //     var timestamp = new Date(date).getTime()
        //     return timestamp
        // },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser',
            'setRefresh'
        ])
    },
    filters: {},
    watch: {
        time2: function(newVal, oldVal) {
            if (newVal != oldVal) {
                if (this.time2 > 0) {
                    setTimeout(()=>{
                        this.time2 = this.time2 - 1000
                    }, 1000)
                }
                // console.log(this.time)
                if (this.time2 === 0) {
                    // console.log('考试结束')
                    if (this.examInfoData.isastrict === 1) {
                        this.examEndPop = true
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters(['loginPop', 'user', 'refresh'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .mexam_view {
        font-family:PingFangSC-Regular,PingFang SC;
        background:rgba(245,247,250,1);
        min-height: 100vh;
        color: #303133;
        .top_time_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 1rem;
            background-color: #fff;
            padding: 0 0.32rem;
            &>div:nth-of-type(1){
                display: flex;
                align-items: center;
                &>img{
                    width: 0.38rem;
                    height: 0.38rem;
                    margin-right: 0.24rem;
                }
                .van-count-down {
                    font-size: 0.32rem;
                    color: #409EFF;
                }
                &>span{
                    font-size: 0.32rem;
                    color: #409EFF;
                }
            }
            &>div:nth-of-type(2){
                &>span{
                    font-size: 0.28rem;
                    color: #999;
                }
                &>span:nth-of-type(1){
                    font-size: 0.36rem;
                    color: #333;
                }
            }
        }
        .exam_warp_box {
            height: calc(100vh - 3.6rem);
            overflow: auto;
            padding: 0.3rem 0.32rem;
            padding-bottom: 1.3rem;
            .subject_box {
                .p_text {
                    font-size: 0.28rem;
                    line-height:0.48rem;
                    text-align: justify;
                    line-height: 1.5;
                    img {
                        max-width: 100%;
                    }
                }
                .answer_box {
                    margin-top: 0.3rem;
                    background-color: #fff;
                    border-radius:0.1rem;
                    overflow: hidden;
                    .van-cell:not(:last-child)::after {
                        width: 90%;
                    }
                    .van-checkbox__icon {
                        line-height: 1.18em;
                    }
                    .optionsinfoItem {
                        line-height: 1.5;
                        img {
                            max-width: 100%;
                        }
                    }
                }
                .answer_type7 {
                    background: #F5F7FA;
                    .item {
                        // background: #fff;
                        &:not(:first-of-type) {
                            margin-top: 0.3rem;
                        }
                        .p_text {
                            background: #F5F7FA;
                        }
                        .materials_answer_box {
                            background: #fff;
                        }
                    }
                }
                .answer_type3 {
                    .van-cell {
                        padding: 0.2rem 0.32rem;
                        padding: 0;
                    }
                    .van-field {
                        padding: 0;
                        padding: 0.2rem 0.32rem;
                    }
                    .van-field__label {
                        width: 0.74rem;
                        white-space: nowrap;
                    }
                }
            }
        }
        .bottom_handle_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.32rem;
            box-sizing: border-box;
            background:#fff;
            width: 100%;
            height: 1rem;
            &>div{
                display: flex;
                align-items: center;
                justify-content: center;
                &>img {
                    width: 0.24rem;
                    height: 0.24rem;
                }
                &>span {
                    color:rgba(64,158,255,1);
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                }
            }
            // &>div:active{
            //     background-color: rgba(0,0,0,0.1);
            // }
            // .handle_div {}
            .scantron_box {
                flex-direction: column;
                &>img {
                    width: 0.38rem;
                    height: 0.38rem;
                }
                &>span {
                    font-size: 0.2rem;
                    line-height: 0.28rem;
                    margin-top: 0.05rem;
                }
            }
        }
        .answer_sheet_pop_box {
            .answer_sheet_content_box {
                width: 100%;
                height: 100%;
                background:rgba(245,247,250,1);
                display: flex;
                flex-direction: column;
                .answer_title_box {
                    // background-color: rgb(179, 231, 179);
                    height: 1rem;
                    line-height: 1rem;
                    text-align: center;
                    font-size: 0.32rem;
                    position: relative;
                    &>img{
                        position: absolute;
                        right: 0.34rem;
                        top: 0.37rem;
                        width: 0.24rem;
                        height: 0.24rem;
                    }
                }
                .answer_select_box {
                    background-color: #fff;
                    flex: 1;
                    padding: 0.32rem;
                    overflow: auto;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    .finished{
                        background:rgba(229,229,229,1)!important;
                    }
                    .answer_item_box{
                        &>div {
                            box-sizing: border-box;
                            width:0.8rem;
                            height:0.8rem;
                            line-height:0.8rem;
                            text-align: center;
                            background:rgba(255,255,255,1);
                            border-radius:0.04rem;
                            border:0.01rem solid rgba(207,207,207,1);
                            margin-right: 0.4rem;
                            margin-top: 0.3rem;
                            font-size: 0.32rem;
                        }
                    }
                    .answer_item_box:nth-of-type(1), .answer_item_box:nth-of-type(2), .answer_item_box:nth-of-type(3), .answer_item_box:nth-of-type(4), .answer_item_box:nth-of-type(5), .answer_item_box:nth-of-type(6){
                        &>div{
                            margin-top: 0;
                        }
                    }
                    .answer_item_box:nth-of-type(6n){
                        &>div{
                            margin-right: 0;
                        }
                    }
                }
                .answer_bottom_box {
                    // background-color: #ccc;
                    height: 1.9rem;
                    &>div:nth-of-type(1){
                        height: 0.9rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &>span{
                            line-height:0.3rem;
                            margin-right: 0.12rem;
                        }
                        &>div{
                            border-radius:0.02rem;
                            border:0.01rem solid rgba(207,207,207,1);
                            width: 0.24rem;
                            height: 0.24rem;
                            background:rgba(229,229,229,1);
                            margin-right: 0.4rem;
                        }
                        &>div:nth-of-type(2){
                            background:rgb(255, 255, 255);
                            margin-right: 0;
                        }
                    }
                    &>div:nth-of-type(2){
                        display: flex;
                        height: 1rem;
                        &>div{
                            width: 50%;
                            text-align: center;
                            line-height: 1rem;
                            font-size: 0.3rem;
                        }
                        &>div:nth-of-type(1){
                            color: #FFF;
                            background:linear-gradient(180deg,rgba(112,182,255,1) 0%,rgba(64,158,255,1) 100%);
                        }
                        &>div:nth-of-type(2){
                            color: #409EFF;
                            background:rgba(230,241,252,1);
                        }
                        // &>div:active{
                        //     background: rgba(0,0,0,0.4);
                        // }
                    }
                }
            }
        }
        .save_progress_pop {
            .van-popup--center {
                background-color: transparent;
                .save_progress_div {
                    &>div {
                        padding: 0.54rem 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 4.6rem;
                        background-color: rgb(255, 255, 255);
                        border-radius:0.15rem;
                        .save_progress_img {
                            width: 2.24rem;
                            height: 1.6rem;
                        }
                        &>p {
                            width: 4rem;
                            margin-top: 0.4rem;
                            text-align: center;
                            font-size: 0.28rem;
                            color: #333;
                            line-height: 0.4rem;
                        }
                        &>p:nth-of-type(2) {
                            margin-top: 0;
                            margin-bottom: 0.4rem;
                        }
                        .van-button {
                            background:linear-gradient(180deg,rgba(64,199,255,1) 0%,rgba(64,158,255,1) 100%);
                            width: 3.48rem;
                            height: 0.6rem;
                            border-radius: 0.3rem;
                            font-size: 0.28rem;
                            border: none;
                            display: flex;
                            justify-content: center;
                            .van-button__text{
                                line-height: 0.6rem;
                            }
                        }
                    }
                }
            }
        }
    }
</style>